import { handleActions } from "redux-actions";

import { setConfigData, setHttpResponse, setIsLoading, setScrapeTask } from "./actions";

const initialState = {
    isLoading: false,
    httpResponse: [],
    configData: {},
    scrapeTask: {}
};

export const generalReducer = handleActions(
    {
        [setIsLoading]: (state, { payload }) => ({
            ...state,
            isLoading: payload
        }),
        [setConfigData]: (state, { payload }) => ({
            ...state,
            configData: payload
        }),
        [setHttpResponse]: (state, { payload }) => ({
            ...state,
            httpResponse: payload
        }),
        [setScrapeTask]: (state, { payload }) => ({
            ...state,
            scrapeTask: payload
        })
    },
    initialState
);
